import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  DocumentState,
  IDocument,
  IDocumentSignatureReminderSettings,
  IDocumentTemplateOptions,
  SendDocMethod,
} from '@kinet-open-network/shared/data-access/model';

export interface DocumentTemplateOption {
  id: string;
  name: string;
  requireSignature?: boolean;
  options?: IDocumentTemplateOptions;
}

export class Document
  extends BaseModel<Document, 'Document'>
  implements IDocument
{
  static override readonly modelName: AbilitySubjectType = 'Document';

  customerId!: number;
  name!: string;
  templateId?: string;
  state!: DocumentState;
  requireSignature!: boolean;
  servicesIds?: string[];
  signatureReminderSettings?: IDocumentSignatureReminderSettings | null;
  lastSentAt?: Date | null;
  lastSendMethod?: SendDocMethod | null;
  reminderCount?: number;
  awaitingSignature?: boolean;
}
